// import axios from "axios";
// import { Navigate } from "react-router-dom";
// import { useState } from "react";
// import { Link } from "react-router-dom";
// import "./Login.css";
// import { API_URL } from "../services/api";

// export const Login = () => {
//   const [username, setUsername] = useState("");
//   const [password, setPassword] = useState("");

//   const submit = async (e) => {
//     e.preventDefault();

//     const user = {
//       username: username,
//       password: password,
//     };

//     const { data } = await axios.post(
//       `${API_URL}token/`,
//       user,
//       {
//         headers: {
//           "Content-Type": "application/json",
//         },
//       },
//       { withCredentials: true }
//     );

//     // console.log(data);
//     localStorage.clear();
//     localStorage.setItem("access_token", data.access);
//     localStorage.setItem("refresh_token", data.refresh);
//     axios.defaults.headers.common["Authorization"] = `Bearer ${data["access"]}`;
//     window.location.href = "/";
//   };
//   //console.log("access", localStorage.getItem("access_token"));

//   return (
//     <div className="signIn">
//       <form className="signInForm" onSubmit={submit}>
//         <div className="signInDiv">
//           <h1 className="signIn-title">Login</h1>
//           <div class="signIn-userpass">
//             <div className="signIn-user">
//               <label>Username</label>
//               <input
//                 className="signIn-input"
//                 placeholder="Enter Username"
//                 name="username"
//                 type="text"
//                 value={username}
//                 required
//                 onChange={(e) => setUsername(e.target.value)}
//               />
//             </div>
//             <div className="signIn-pass">
//               <label>Password</label>
//               <input
//                 name="password"
//                 type="password"
//                 className="signIn-input"
//                 placeholder="Enter password"
//                 value={password}
//                 required
//                 onChange={(e) => setPassword(e.target.value)}
//               />
//             </div>
//           </div>
//           <div className="signIn-button">
//             <button type="submit" className="signIn-but">
//               Submit
//             </button>
//           </div>

//           <div className="signIn-register">
//             <p>
//               Don't have an account? <Link to="/register">Register here</Link>
//             </p>
//           </div>
//           <p className="text-sm mt-2">
//             <a href="/password-reset" className="text-blue-600 hover:underline">
//               Forgot your password?
//             </a>
//           </p>
//         </div>
//       </form>
//     </div>
//   );
// };

// export default Login;

// trying with error
import axios from "axios";
import { useState } from "react";
import { Link } from "react-router-dom";
import "./Login.css";
import { API_URL } from "../services/api";
import shrokImg from "./shrok.svg";

export const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(""); // Add error state

  const submit = async (e) => {
    e.preventDefault();

    // Clear any previous error message
    setError("");

    const user = {
      username: username,
      password: password,
    };

    try {
      const { data } = await axios.post(
        `${API_URL}token/`,
        user,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
        { withCredentials: true }
      );
      const redirect = localStorage.getItem("product_redirect");
      localStorage.clear();
      localStorage.setItem("access_token", data.access);
      localStorage.setItem("refresh_token", data.refresh);
      axios.defaults.headers.common[
        "Authorization"
      ] = `Bearer ${data["access"]}`;

      window.location.href = redirect ? redirect : "/";
    } catch (err) {
      // Check for 401 error
      if (err.response && err.response.status === 401) {
        setError("Either Password or Username is Incorrect, please try again");
      } else {
        setError("An error occurred. Please try again later.");
      }
    }
  };

  return (
    <div className="signIn">
      {/* <img src={shrokImg} alt="Shrok Image" className="shrokImgBg"></img> */}
      <form className="signInForm" onSubmit={submit}>
        <div className="signInDiv">
          <h1 className="signIn-title">Login</h1>

          {/* Display error message if it exists */}
          {error && <div className="error-message">{error}</div>}

          <div className="signIn-userpass">
            <div className="signIn-user">
              <label>Username: </label>
              <input
                className="signIn-input"
                placeholder="Eg) shrok33"
                name="username"
                type="text"
                value={username}
                required
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
            <div className="signIn-pass">
              <label>Password: </label>
              <input
                name="password"
                type="password"
                className="signIn-input"
                placeholder="Eg) verdureShr@k"
                value={password}
                required
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="signIn-button">
            <button type="submit" className="signIn-but">
              Submit
            </button>
          </div>

          <div className="signIn-register">
            <p>
              Don't have an account? <Link to="/register">Register here</Link>
            </p>
            <p className="text-sm mt-2">
              <a
                href="/password-reset"
                className="text-blue-600 hover:underline"
              >
                Forgot your password?
              </a>
            </p>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
